// lib/filters/parseOrderLink
var name = 'train-in-way-info'
var link = 'train-in-way-info'

function parseLink(name = null, parseLink = null) {
    return function (number, dataset) {
        if (number) number = number.trim()
        var link = parseLink + '/' + number
        var data = {}

        data.name = name
        if (dataset.number) data.number = dataset.number
        if (dataset.date)   data.date = dataset.date
        if (dataset.cargo)   data.cargo = dataset.cargo
        if (dataset.destination)   data.destination = dataset.destination
        if (dataset.seal)   data.seal = dataset.seal
        if (dataset.station)   data.station = dataset.station
        if (dataset.train)   data.train = dataset.train
        if (dataset.transport)   data.transport = dataset.transport
        if (dataset.weight)   data.weight = dataset.weight
        if (dataset.size)   data.size = dataset.size
        if (dataset.type)   data.type = dataset.type



        data = JSON.stringify(data)
        return `<a data-data='${data}' href="${link}">${number}</a>`
    }

}


export default {
    filters: {parseTrainInWayLink: parseLink(name, link)}
}



/** WEBPACK FOOTER **
 ** ./src/js/lib/filters/parseTrainInWayLink.js
 **/